/**
 * Minimal i18n stub — @core/initCore.js calls useI18n({ useScope: 'global' })
 * internally so vue-i18n must be installed via app.use even if we don't use
 * translations. This stub registers a single English locale to satisfy that
 * requirement without shipping translation JSON files.
 */
import { createI18n } from "vue-i18n";

const i18n = createI18n({
  legacy: false, // Composition API mode (required by initCore)
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en: {}, // No translations needed for hr-admin
  },
});

export const getI18n = () => i18n;

export default function (app) {
  app.use(i18n);
}
